/* Costack "Build your own spice box" - 23 Jun 2026
 * Open mix builder: pick any blends, running total + £35 free-delivery progress,
 * add the whole box to cart in one go. No discount engine (free delivery is the
 * only incentive). Reads products from a collection's products.json. Self-contained.
 */
(function () {
  'use strict';
  var mount = document.getElementById('cstk-byob');
  if (!mount) return;
  var COLL = mount.getAttribute('data-collection') || 'all-spices-and-seasonings';
  var THRESHOLD = parseInt(mount.getAttribute('data-threshold') || '3500', 10);

  var state = {};

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function imgUrl(src) { if (!src) return ''; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=300'; }

  var CSS = [
    '#cstk-byob{font-family:inherit;}',
    '.byob-head{text-align:center;margin:0 0 6px;font-size:24px;font-weight:500;color:#231900;}',
    '.byob-sub{text-align:center;color:#6b6b6b;font-size:14px;margin:0 0 18px;}',
    '.byob-bar{position:sticky;top:0;z-index:5;background:#fffaf2;border:1px solid #f0d089;border-radius:10px;padding:10px 14px;margin:0 0 16px;}',
    '.byob-bar__txt{font-size:13px;color:#231900;margin:0 0 6px;}',
    '.byob-bar__txt strong{color:#b3641c;}',
    '.byob-track{height:7px;background:#efe6d8;border-radius:20px;overflow:hidden;}',
    '.byob-fill{height:100%;background:#b3641c;border-radius:20px;transition:width .3s ease;}',
    '.byob-bar.is-unlocked{background:#e8f6e9;border-color:#bfe3c2;}',
    '.byob-bar.is-unlocked .byob-bar__txt strong{color:#15691a;}',
    '.byob-bar.is-unlocked .byob-track{background:#cfe9d1;}',
    '.byob-bar.is-unlocked .byob-fill{background:#15691a;}',
    '.byob-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;}',
    '.byob-card{border:0.5px solid #e0d5c2;border-radius:10px;padding:9px;display:flex;flex-direction:column;}',
    '.byob-card.is-in{border-color:#b3641c;box-shadow:0 0 0 1px #b3641c inset;}',
    '.byob-card__img{height:104px;border-radius:7px;overflow:hidden;background:#f5f1ea;margin-bottom:8px;}',
    '.byob-card__img img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.byob-card__t{font-size:13px;font-weight:600;color:#231900;line-height:1.3;min-height:34px;}',
    '.byob-card__p{font-size:13px;font-weight:700;color:#b3641c;margin:3px 0 8px;}',
    '.byob-add{margin-top:auto;width:100%;height:40px;border:1px solid #b3641c;background:#fff;color:#b3641c;border-radius:8px;font-weight:700;font-size:13px;cursor:pointer;}',
    '.byob-add:hover{background:#fff3e6;}',
    '.byob-step{margin-top:auto;display:flex;align-items:center;justify-content:space-between;border:1px solid #b3641c;border-radius:8px;height:40px;overflow:hidden;}',
    '.byob-step button{width:42px;height:100%;border:0;background:#fff;color:#b3641c;font-size:18px;cursor:pointer;}',
    '.byob-step span{font-size:14px;font-weight:700;}',
    '.byob-foot{position:sticky;bottom:0;z-index:6;display:flex;align-items:center;gap:12px;background:#fff;border-top:1px solid #ecdfc8;padding:12px 0;margin-top:18px;}',
    '.byob-foot__i{flex:1;}',
    '.byob-foot__c{font-size:12px;color:#6b6b6b;}',
    '.byob-foot__v{font-size:20px;font-weight:500;color:#231900;}',
    '.byob-foot__b{flex:0 0 auto;height:50px;padding:0 24px;background:#b3641c;color:#fff;border:0;border-radius:8px;font-size:16px;font-weight:500;cursor:pointer;}',
    '.byob-foot__b[disabled]{background:#c9bda8;cursor:not-allowed;}'
  ].join('');

  function buyableVariant(p) {
    var avail = (p.variants || []).filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var single = avail.find(function (v) { return /single/i.test(v.title); });
    if (single) return single;
    avail.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    return avail[0];
  }

  function totals(products) {
    var pence = 0, count = 0;
    products.forEach(function (p) {
      var q = state[p._vid] || 0;
      if (q) { pence += q * p._price; count += q; }
    });
    return { pence: pence, count: count };
  }

  function render(products) {
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

    mount.innerHTML =
      '<h1 class="byob-head">Build your own spice box</h1>'
      + '<p class="byob-sub">Pick any blends. Hit ' + money(THRESHOLD) + ' for free UK delivery.</p>'
      + '<div class="byob-bar"><p class="byob-bar__txt" data-bar></p><div class="byob-track"><div class="byob-fill" data-fill style="width:0%"></div></div></div>'
      + '<div class="byob-grid" data-grid></div>'
      + '<div class="byob-foot"><div class="byob-foot__i"><div class="byob-foot__c" data-count>0 in box</div><div class="byob-foot__v" data-total>£0.00</div></div><button class="byob-foot__b" data-add disabled>Add box to basket</button></div>';

    var grid = mount.querySelector('[data-grid]');
    products.forEach(function (p) {
      var card = document.createElement('div');
      card.className = 'byob-card';
      card.setAttribute('data-card', p._vid);
      card.innerHTML =
        '<div class="byob-card__img">' + (p._img ? '<img loading="lazy" src="' + imgUrl(p._img) + '" alt="">' : '') + '</div>'
        + '<div class="byob-card__t">' + esc(p.title.replace(/^Costack\s+/, '')) + '</div>'
        + '<div class="byob-card__p">' + money(p._price) + '</div>'
        + '<button class="byob-add" data-addbtn>+ Add</button>';
      grid.appendChild(card);
    });

    function syncCard(p) {
      var card = grid.querySelector('[data-card="' + p._vid + '"]');
      var q = state[p._vid] || 0;
      card.classList.toggle('is-in', q > 0);
      var holder = card.lastElementChild;
      if (q > 0) {
        if (!card.querySelector('.byob-step')) {
          var step = document.createElement('div'); step.className = 'byob-step';
          step.innerHTML = '<button data-minus aria-label="Remove one">−</button><span data-q>' + q + '</span><button data-plus aria-label="Add one">+</button>';
          card.replaceChild(step, holder);
        } else { card.querySelector('[data-q]').textContent = q; }
      } else {
        if (!card.querySelector('.byob-add')) {
          var b = document.createElement('button'); b.className = 'byob-add'; b.setAttribute('data-addbtn', ''); b.textContent = '+ Add';
          card.replaceChild(b, card.querySelector('.byob-step'));
        }
      }
    }

    function syncTotals() {
      var t = totals(products);
      mount.querySelector('[data-count]').textContent = t.count + (t.count === 1 ? ' item in box' : ' in box');
      mount.querySelector('[data-total]').textContent = money(t.pence);
      var pct = Math.min(100, Math.round(t.pence * 100 / THRESHOLD));
      mount.querySelector('[data-fill]').style.width = pct + '%';
      var bar = mount.querySelector('[data-bar]');
      var barWrap = mount.querySelector('.byob-bar');
      if (barWrap) barWrap.classList.toggle('is-unlocked', t.pence >= THRESHOLD);
      if (t.pence >= THRESHOLD) bar.innerHTML = '🎉 <strong>Free UK delivery unlocked!</strong>';
      else if (t.pence > 0) bar.innerHTML = money(t.pence) + ' in box · <strong>' + money(THRESHOLD - t.pence) + '</strong> to free delivery';
      else bar.innerHTML = 'Add blends to your box · free UK delivery over <strong>' + money(THRESHOLD) + '</strong>';
      var add = mount.querySelector('[data-add]');
      add.disabled = t.count === 0;
      add.textContent = t.count === 0 ? 'Add box to basket' : 'Add ' + t.count + ' to basket · ' + money(t.pence);
    }

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('[data-card]'); if (!card) return;
      var vid = card.getAttribute('data-card');
      var p = products.find(function (x) { return String(x._vid) === vid; });
      if (e.target.closest('[data-addbtn]')) state[vid] = 1;
      else if (e.target.closest('[data-plus]')) state[vid] = (state[vid] || 0) + 1;
      else if (e.target.closest('[data-minus]')) state[vid] = Math.max(0, (state[vid] || 0) - 1);
      else return;
      syncCard(p); syncTotals();
    });

    mount.querySelector('[data-add]').addEventListener('click', function () {
      var items = [];
      products.forEach(function (p) { var q = state[p._vid] || 0; if (q) items.push({ id: parseInt(p._vid, 10), quantity: q }); });
      if (!items.length) return;
      var btn = this; btn.disabled = true; btn.textContent = 'Adding...';
      fetch('/cart/add', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
    });

    syncTotals();
  }

  fetch('/collections/' + COLL + '/products.json?limit=50', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.products || []).map(function (p) {
        var v = buyableVariant(p);
        if (!v) return null;
        p._vid = v.id; p._price = Math.round(parseFloat(v.price) * 100);
        p._img = (p.images && p.images[0]) ? p.images[0].src : '';
        return p;
      }).filter(Boolean).filter(function (p) { return p._price < 2000; });
      if (!products.length) { mount.innerHTML = '<p style="text-align:center">No spices available right now.</p>'; return; }
      render(products);
    })
    .catch(function () { mount.innerHTML = '<p style="text-align:center">Could not load spices. Please refresh.</p>'; });
})();
